import { columnTypes, isColumnGroup, type ColumnDynamics, type ColumnOrColumnGroup } from '@talos/kyoko';
import type { ColDef, ColGroupDef } from 'ag-grid-community';
import type { MarketSelectorItem, MarketSelectorValue } from '../../../MarketSelector/types';

export function getMarketsFromSelectorValue(marketSelectorValue?: MarketSelectorValue): string[] {
  const selections = marketSelectorValue?.selections;
  return selections ?? [];
}

function convertColumnToColDef(column: ColumnOrColumnGroup): ColDef | ColGroupDef {
  return isColumnGroup(column)
    ? { ...column, children: column.children.map(child => columnTypes[child.type](child)) }
    : columnTypes[column.type](column);
}

export function buildPriceGridMarketDataColumnColDef<TSettings>({
  getColumn,
  dynamics,
  newSettings,
  getColDefOverlay,
}: {
  getColumn: (dynamics: ColumnDynamics<TSettings>) => ColumnOrColumnGroup;
  dynamics: ColumnDynamics<TSettings>;
  newSettings: TSettings | undefined;
  getColDefOverlay?: (dynamics: ColumnDynamics<TSettings>) => Partial<ColDef | ColGroupDef>;
}): ColDef | ColGroupDef {
  const updatedDynamics = { ...dynamics, state: newSettings };
  const colDef = convertColumnToColDef(getColumn(updatedDynamics));

  if (getColDefOverlay) {
    Object.assign(colDef, getColDefOverlay(updatedDynamics));
  }

  return colDef;
}

export function getLegMarketDataColumnField(legIndex: number | undefined) {
  return legIndex == null ? undefined : `security.MultilegDetails.Legs[${legIndex}].Symbol`;
}

export function getMarketSelectorItemDisplayName(
  selection: string,
  marketSelectorItemsByName: Map<string, MarketSelectorItem>
) {
  return marketSelectorItemsByName.get(selection)?.displayName ?? selection;
}
